import { atom, useAtom, useAtomValue } from 'jotai';

// <tokenContract, usdPrice>
const tokenPricesAtom = atom<Record<string, number>>({});
const lastUpdatedAtom = atom<number>(0);

export const useTokenPrices = () => {
  const [tokenPrices, setTokenPrices] = useAtom(tokenPricesAtom);
  const [lastUpdated, setLastUpdated] = useAtom(lastUpdatedAtom);

  return {
    tokenPrices,
    setTokenPrices,
    lastUpdated,
    setLastUpdated,
  };
};

export const useStxPrice = () => useAtomValue(tokenPricesAtom)['STX'];
